import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';

var spriteSheetType = function spriteSheetType(sprite) {
  switch (sprite) {
    case 'review-positive':
    case 'review-negative':
      return 'https://s3.us-east-2.amazonaws.com/likeablelocal/fb-review-spritesheet-2019-05-29.png';

    default:
      return 'https://s3.us-east-2.amazonaws.com/likeablelocal/fb-spritesheet-2019-05-20.png';
  }
};

export default function FBSprite(_ref) {
  var name = _ref.name,
      style = _ref.style,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, ["name", "style", "onClick"]);

  var spriteSheetUrl = spriteSheetType(name);

  var defaultStyle = _objectSpread({
    backgroundImage: "url(".concat(spriteSheetUrl, ")"),
    backgroundRepeat: 'no-repeat',
    backgroundSize: '140px 836px',
    height: 16,
    width: 16
  }, onClick ? {
    cursor: 'pointer'
  } : {});

  switch (name) {
    case 'smile-light':
      defaultStyle.backgroundPosition = '-85px -684px';
      break;

    case 'camera-light':
      defaultStyle.backgroundPosition = '-34px -684px';
      break;

    case 'gif-light':
      defaultStyle.backgroundPosition = '-119px -701px';
      break;

    case 'sticker-light':
      defaultStyle.backgroundPosition = '-51px -752px';
      break;

    case 'like-color-small':
      defaultStyle.backgroundPosition = '-49px -1069px';
      break;

    case 'review-positive':
      defaultStyle.backgroundSize = '51px 303px';
      defaultStyle.backgroundPosition = '0 -286px';
      break;

    case 'review-negative':
      defaultStyle.backgroundSize = '51px 303px';
      defaultStyle.backgroundPosition = '16px -286px';
      break;
  }

  return /*#__PURE__*/React.createElement("div", _extends({
    onClick: onClick,
    style: _objectSpread(_objectSpread({}, defaultStyle), style || {})
  }, rest));
}